import {SECTIONS} from 'constants/NavConstants';
import {getStore} from 'redux-stores/Store';
import {maybeRefreshListing} from 'search/SearchUIReduxActions';
import {getStudyItemListingSearchSessionId} from 'studies/workspace/StudySearchHelpers';

export default function refreshListings(additionalSearchSessionIds?: Array<string>): void {
  /* TODO: Narrow refreshListings by item type via introspection utils */
  const sessionIdsToRefresh = [...Object.values(SECTIONS), ...(additionalSearchSessionIds ?? [])];
  for (const sessionId of sessionIdsToRefresh) {
    getStore().dispatch(maybeRefreshListing(sessionId));
  }
}

export function refreshStudyItemListings(studyIds: Array<string>): void {
  for (const studyId of studyIds) {
    getStore().dispatch(maybeRefreshListing(getStudyItemListingSearchSessionId(studyId)));
  }
}
